import { render, staticRenderFns } from "./DownloadReportPopUp.vue?vue&type=template&id=452ccd46&scoped=true&"
import script from "./DownloadReportPopUp.vue?vue&type=script&lang=js&"
export * from "./DownloadReportPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452ccd46",
  null
  
)

export default component.exports